import React from 'react';
import { MessageCircle } from 'lucide-react';
import { mockData } from '../mock/data';

export const Hero = () => {
  const { hero } = mockData;

  const whatsappNumber = '5521965983038';
  const whatsappMessage = 'Olá, vim pelo Google e quero mais informações para fazer parte do time de Traders.';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <section id="hero" className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          {/* Badge */}
          <div className="hero-badge">
            <span className="badge-dot"></span>
            <span className="badge-text">Regulada pela FSA</span>
          </div>

          {/* Main Content */}
          <h1 className="hero-title">
            {hero.title}
          </h1>
          
          <p className="hero-subtitle">
            {hero.subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="hero-cta-group">
            <a 
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary hero-btn"
            >
              <MessageCircle size={20} />
              Comece agora
            </a>
          </div>

          {/* Stats */}
          <div className="hero-stats">
            {mockData.stats.map((stat) => (
              <div key={stat.id} className="hero-stat-item">
                <div className="stat-value">{stat.value}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Visual Element */}
        <div className="hero-visual">
          <div className="visual-card">
            <div className="visual-glow"></div>
            <div className="trading-mockup">
              <div className="mockup-header">
                <div className="mockup-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <span className="mockup-title">TradingView Pro</span>
              </div>
              <div className="mockup-chart">
                <div className="chart-line"></div>
                <div className="chart-bars">
                  <div className="bar" style={{height: '60%'}}></div>
                  <div className="bar" style={{height: '40%'}}></div>
                  <div className="bar" style={{height: '80%'}}></div>
                  <div className="bar" style={{height: '55%'}}></div>
                  <div className="bar" style={{height: '90%'}}></div>
                  <div className="bar" style={{height: '70%'}}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
